Array.from(document.getElementsByClassName('product-form__input--radios')).forEach(circleRadios => {
  let circleRadiosInputArr = Array.from(circleRadios.getElementsByTagName('input'));
  let selectBlock = document.getElementsByClassName(`product-form-${circleRadios.dataset.productId}`)[0].getElementsByClassName(`select-block-${circleRadios.dataset.type}`)[0];
  // Update select on circle radio button click
  circleRadiosInputArr.forEach( input => {
    input.addEventListener('click', e => {
      //let selectBlock = document.getElementsByClassName(`product-form-${circleRadios.dataset.productId}`)[0].getElementsByClassName(`select-block-${circleRadios.dataset.type}`)[0];
      Array.from(selectBlock.getElementsByClassName('custom-select__item')).forEach( el => {
        if(el.dataset.selectItem == input.value){
          el.click();
          let value = input.value;
          if(value === "OS"){
            value = "One Size"
          }
          circleRadios.getElementsByClassName('selectedOption')[0].innerHTML = value;
        }
      })
      updateOptions(circleRadios.dataset.productId, input.dataset.optionIndex, input.value);
    })
  }) 

  // Update circle radio buttons on select changes (sticky ATC)
  setTimeout(()=>{
    Array.from(selectBlock.getElementsByClassName('custom-select__item')).forEach(customSelectItem => {
      customSelectItem.addEventListener('click', () => {
        circleRadiosInputArr.forEach(input => {
          input.checked = false
        })
        circleRadiosInputArr.forEach(input => {
          if(input.value == customSelectItem.dataset.selectItem ){
            input.checked = true
          }
        })
      })
    })
  }, 2000)
})


function updateOptions(productId, optionIndex, value) {
  let dataDiv = document.getElementById(`product-${productId}-variants`);
  let variantData = JSON.parse(dataDiv.dataset.variants);
  console.log(variantData)
  let available = [];
  if(optionIndex == 1){
    available = variantData.filter( v => v.option1 == value && v.available == "true")
  } else if(optionIndex == 2){
    available = variantData.filter( v => v.option2 == value && v.available == "true")
  } else if(optionIndex == 3){
    available = variantData.filter( v => v.option3 == value && v.available == "true")
  }
  console.log(available)
}